import React from 'react';
import { EyeIcon, SparklesIcon, BrainCircuitIcon } from 'lucide-react';
export function MethodSection() {
  return <section className="py-24 bg-orange-50" data-id="element-103">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-104">
        <div className="text-center mb-16" data-id="element-105">
          <span className="text-orange-600 font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-106">
            El Secreto
          </span>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-stone-900 mb-6" data-id="element-107">
            El Método de "Zonas de Fuego"
          </h2>
          <p className="text-xl text-stone-600 max-w-3xl mx-auto" data-id="element-108">
            Este sistema no es un manual de limpieza tradicional. Es una
            estrategia de guerra visual.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-109">
          <div className="bg-white rounded-3xl p-8 shadow-sm border border-orange-100 text-center relative overflow-hidden group hover:shadow-md transition-shadow" data-id="element-110">
            <div className="absolute top-0 left-0 w-full h-1 bg-orange-400 transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300" data-id="element-111"></div>
            <div className="w-14 h-14 bg-orange-100 rounded-2xl flex items-center justify-center mx-auto mb-6 text-orange-600" data-id="element-112">
              <EyeIcon className="w-7 h-7" data-id="element-113" />
            </div>
            <h3 className="text-xl font-bold text-stone-900 mb-4" data-id="element-114">
              Puntos de Enfoque
            </h3>
            <p className="text-stone-600" data-id="element-115">
              Identificamos los 3 puntos exactos donde aterriza el ojo de tu
              invitado (El Umbral, El Aterrizaje y El Servicio).
            </p>
          </div>

          <div className="bg-white rounded-3xl p-8 shadow-sm border border-orange-100 text-center relative overflow-hidden group hover:shadow-md transition-shadow" data-id="element-116">
            <div className="absolute top-0 left-0 w-full h-1 bg-orange-400 transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300" data-id="element-117"></div>
            <div className="w-14 h-14 bg-orange-100 rounded-2xl flex items-center justify-center mx-auto mb-6 text-orange-600" data-id="element-118">
              <SparklesIcon className="w-7 h-7" data-id="element-119" />
            </div>
            <h3 className="text-xl font-bold text-stone-900 mb-4" data-id="element-120">
              Efecto Halo
            </h3>
            <p className="text-stone-600" data-id="element-121">
              Si estos puntos estratégicos brillan, el cerebro del invitado
              asume automáticamente que toda la casa está limpia.
            </p>
          </div>

          <div className="bg-white rounded-3xl p-8 shadow-sm border border-orange-100 text-center relative overflow-hidden group hover:shadow-md transition-shadow" data-id="element-122">
            <div className="absolute top-0 left-0 w-full h-1 bg-orange-400 transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300" data-id="element-123"></div>
            <div className="w-14 h-14 bg-orange-100 rounded-2xl flex items-center justify-center mx-auto mb-6 text-orange-600" data-id="element-124">
              <BrainCircuitIcon className="w-7 h-7" data-id="element-125" />
            </div>
            <h3 className="text-xl font-bold text-stone-900 mb-4" data-id="element-126">
              Psicología Aplicada
            </h3>
            <p className="text-stone-600" data-id="element-127">
              No es limpiar más duro, es limpiar de manera más inteligente. Es
              psicología aplicada al hogar para engañar al ojo humano.
            </p>
          </div>
        </div>
      </div>
    </section>;
}